export interface BaseModel {
    mobile_columns: any[];
    tablet_columns: any[];
}

export class ColumnsDefaultModel {
    static suppliers: BaseModel = {
        // tablet_landscape_columns: [
        //     {"colId": "0", "width": 70, "hide": false, "pinned": "left", "flex": 1},
        //     {"colId": "name", "hide": false, "flex": 1},
        //     {"colId": "phone1", "hide": false, "flex": 1},
        //     {"colId": "email1", "hide": false, "flex": 1},
        //     {"colId": "email_pec", "hide": false, "flex": 1},
        //     {"colId": "params", "width": 100, "hide": false, "pinned": "right"}
        // ],
        // tablet_portrait_columns: [
        //     {"colId": "0", "width": 70, "hide": false, "pinned": "left", "flex": 1},
        //     {"colId": "name", "hide": false, "flex": 1},
        //     {"colId": "phone1", "hide": false, "flex": 1},
        //     {"colId": "email_pec", "hide": false, "flex": 1},
        //     {"colId": "params", "width": 100, "hide": false, "pinned": "right"}],
        // mobile_landscape_columns: [
        //     {"colId": "0", "width": 70, "hide": false, "pinned": "left", "flex": 1},
        //     {"colId": "name", "hide": false, "flex": 1},
        //     {"colId": "phone1", "hide": false, "flex": 1},
        //     {"colId": "email1", "hide": false, "flex": 1},
        //     {"colId": "email_pec", "hide": false, "flex": 1},
        //     {"colId": "params", "width": 100, "hide": false, "pinned": "right"}],
        // mobile_portrait_columns: [
        //     {"colId": "0", "width": 70, "hide": false, "pinned": "left", "flex": 1},
        //     {"colId": "name", "hide": false, "flex": 1},
        //     {"colId": "phone1", "hide": false, "flex": 1},
        //     {"colId": "email_pec", "hide": false, "flex": 1},
        //     {"colId": "params", "width": 100, "hide": false, "pinned": "right"}],
        //     tablet_landscape_columns: [
        //         {"colId": "0", "width": 70, "hide": false, "pinned": "left", "flex": 1},
        //         {"colId": "name", "hide": false, "flex": 1},
        //         {"colId": "phone1", "hide": false, "flex": 1},
        //         {"colId": "email1", "hide": false, "flex": 1},
        //         {"colId": "email_pec", "hide": false, "flex": 1},
        //         {"colId": "params", "width": 100, "hide": false, "pinned": "right"}
        //     ],
        //     tablet_portrait_columns: [
        //         {"colId": "0", "width": 70, "hide": false, "pinned": "left", "flex": 1},
        //         {"colId": "name", "hide": false, "flex": 1},
        //         {"colId": "phone1", "hide": false, "flex": 1},
        //         {"colId": "email_pec", "hide": false, "flex": 1},
        //         {"colId": "params", "width": 100, "hide": false, "pinned": "right"}],
        tablet_columns: [
            {"colId": "0","minWidth": 50, "width": 50, "hide": false, "pinned": "left"},
            {"colId": "name", "hide": false, "flex": 1},
            {"colId": "phone1", "hide": false, "flex": 1},
            {"colId": "email1", "hide": false, "flex": 1},
            {"colId": "email_pec", "hide": false, "flex": 1},
            {"colId": "params", "minWidth":62, "width": 62, "hide": false, "pinned": "right"}],
        mobile_columns: [
            {"colId": "0", "minWidth": 50, "width": 50, "hide": false, "pinned": "left"},
            {"colId": "name", "hide": false, "flex": 1},
            {"colId": "phone1", "hide": false, "flex": 1},
            {"colId": "email1", "hide": false, "flex": 1},
            {"colId": "email_pec", "hide": false, "flex": 1},
            {"colId": "params", "minWidth":62, "width": 62, "hide": false, "pinned": "right"}]

    };
    static customers: BaseModel = {
        // tablet_landscape_columns: [
        //     {"colId": "0", "width": 70, "hide": false, "pinned": "left", "flex": 1},
        //     {"colId": "company_name", "hide": false, "flex": 1},
        //     {"colId": "first_name", "hide": false, "flex": 1},
        //     {"colId": "last_name", "hide": false, "flex": 1},
        //     {"colId": "tot_spent", "hide": false, "flex": 1},
        //     {"colId": "fidelity", "hide": false, "flex": 1},
        //     {"colId": "avg_spent", "hide": false, "flex": 1},
        //     {"colId": "params", "hide": false, "pinned": "right", "flex": 1}
        // ],
        // tablet_portrait_columns: [
        //     {"colId": "0", "width": 70, "hide": false, "pinned": "left", "flex": 1},
        //     {"colId": "company_name", "hide": false, "flex": 1},
        //     {"colId": "first_name", "hide": false, "flex": 1},
        //     {"colId": "last_name", "hide": false, "flex": 1},
        //     {"colId": "tot_spent", "hide": false, "flex": 1},
        //     {"colId": "fidelity", "hide": false, "flex": 1},
        //     {"colId": "avg_spent", "hide": false, "flex": 1},
        //     {"colId": "params", "hide": false, "pinned": "right", "flex": 1}
        // ],
        // mobile_landscape_columns: [
        //     {"colId": "0", "width": 70, "hide": false, "pinned": "left", "flex": 1},
        //     {"colId": "company_name", "hide": false, "flex": 1},
        //     {"colId": "first_name", "hide": false, "flex": 1},
        //     {"colId": "last_name", "hide": false, "flex": 1},
        //     {"colId": "tot_spent", "hide": false, "flex": 1},
        //     {"colId": "avg_spent", "hide": false, "flex": 1},
        //     {"colId": "params", "hide": false, "pinned": "right", "flex": 1}
        // ],
        // mobile_portrait_columns: [
        //     {"colId": "0", "width": 70, "hide": false, "pinned": "left", "flex": 1},
        //     {"colId": "company_name", "hide": false, "flex": 1},
        //     {"colId": "first_name", "hide": false, "flex": 1},
        //     {"colId": "last_name", "hide": false, "flex": 1},
        //     {"colId": "tot_spent", "hide": false, "flex": 1},
        //     {"colId": "avg_spent", "hide": false, "flex": 1},
        //     {"colId": "params", "hide": false, "pinned": "right", "flex": 1}
        // ],
        tablet_columns: [
            {"colId": "0", "minWidth": 50, "width": 50, "hide": false, "pinned": "left"},
            {"colId": "company_name", "hide": false, "flex": 1},
            {"colId": "first_name", "hide": false, "flex": 1},
            {"colId": "last_name", "hide": false, "flex": 1},
            {"colId": "tot_spent", "hide": false, "flex": 1},
            {"colId": "fidelity", "hide": false, "flex": 1},
            {"colId": "avg_spent", "hide": false, "flex": 1},
            {"colId": "params", "minWidth":62, "width": 62, "hide": false, "pinned": "right"}
        ],
        mobile_columns: [
            {"colId": "0", "minWidth": 50, "width": 50, "hide": false, "pinned": "left"},
            {"colId": "company_name", "hide": false, "flex": 1},
            {"colId": "first_name", "hide": false, "flex": 1},
            {"colId": "last_name", "hide": false, "flex": 1},
            {"colId": "tot_spent", "hide": false, "flex": 1},
            {"colId": "avg_spent", "hide": false, "flex": 1},
            {"colId": "params", "minWidth":62, "width": 62, "hide": false, "pinned": "right"}
        ],
    };
    static history_sales: BaseModel = {
        // tablet_landscape_columns: [
        //     {"colId": "0", "width": 70, "hide": false, "pinned": "left", "flex": 1},
        //     {"colId": "closed_at", "hide": false, "flex": 1},
        //     {"colId": "sale_number", "hide": false, "flex": 1},
        //     {"colId": "is_summary", "hide": false, "flex": 1},
        //     {"colId": "final_amount", "hide": false, "flex": 1},
        //     {"colId": "channel", "hide": false, "flex": 1},
        //     {"colId": "seller_name", "hide": false, "flex": 1},
        //     {"colId": "customer_name", "hide": false, "flex": 1},
        //     {"colId": "params", "hide": false, "pinned": "right", "flex": 1}
        // ],
        // tablet_portrait_columns: [
        //     {"colId": "0", "width": 70, "hide": false, "pinned": "left", "flex": 1},
        //     {"colId": "closed_at", "hide": false, "flex": 1},
        //     {"colId": "sale_number", "hide": false, "flex": 1},
        //     {"colId": "is_summary", "hide": false, "flex": 1},
        //     {"colId": "final_amount", "hide": false, "flex": 1},
        //     {"colId": "channel", "hide": false, "flex": 1},
        //     {"colId": "seller_name", "hide": false, "flex": 1},
        //     {"colId": "customer_name", "hide": false, "flex": 1},
        //     {"colId": "params", "hide": false, "pinned": "right", "flex": 1}
        // ],
        // mobile_landscape_columns: [
        //     {"colId": "0", "width": 70, "hide": false, "pinned": "left", "flex": 1},
        //     {"colId": "closed_at", "hide": false, "flex": 1},
        //     {"colId": "sale_number", "hide": false, "flex": 1},
        //     {"colId": "final_amount", "hide": false, "flex": 1},
        //     {"colId": "customer_name", "hide": false, "flex": 1},
        //     {"colId": "params", "hide": false, "pinned": "right", "flex": 1}
        // ],
        // mobile_portrait_columns: [
        //     {"colId": "0", "width": 70, "hide": false, "pinned": "left", "flex": 1},
        //     {"colId": "closed_at", "hide": false, "flex": 1},
        //     {"colId": "sale_number", "hide": false, "flex": 1},
        //     {"colId": "final_amount", "hide": false, "flex": 1},
        //     {"colId": "customer_name", "hide": false, "flex": 1},
        //     {"colId": "params", "hide": false, "pinned": "right", "flex": 1}
        // ]
        tablet_columns: [
            {"colId": "id", "minWidth": 50, "width": 50, "hide": true, "pinned": "left"},
            {"colId": "closed_at", "hide": false, "flex": 1},
            {"colId": "type_document", "hide": false, "flex": 1},
            {"colId": "sale_number", "hide": false, "flex": 1},
            {"colId": "final_amount", "hide": false, "flex": 1},
            {"colId": "printer", "hide": false, "flex": 1},
            {"colId": "is_summary", "hide": false, "flex": 1},
            {"colId": "channel", "hide": false, "flex": 1},
            {"colId": "seller_name", "hide": false, "flex": 1},
            {"colId": "customer_name", "hide": false, "flex": 1},
            {"colId": "payment_type", "hide": false, "flex": 1},
            {"colId": "sequential_number", "hide": false, "flex": 1},
            {"colId": "params", "minWidth":62, "width": 62, "hide": false, "pinned": "right"}
        ],
        mobile_columns: [
            {"colId": "0", "minWidth": 50, "width": 50, "hide": false, "pinned": "left"},
            {"colId": "closed_at", "hide": false, "flex": 1},
            {"colId": "sale_number", "hide": false, "flex": 1},
            {"colId": "final_amount", "hide": false, "flex": 1},
            {"colId": "params", "minWidth":62, "width": 62, "hide": false, "pinned": "right"}
        ]
    };

    static history_sales_data_sent: BaseModel = {
        tablet_columns: [
            {"colId": "0", "minWidth": 50, "width": 50, "hide": false, "pinned": "left"},
            {"colId": "closed_at", "hide": false, "flex": 0.8},
            {"colId": "sale_data_sent.0.created_at", "hide": false, "flex": 0.8},
            {"colId": "name", "hide": false, "flex": 1},
            {"colId": "final_amount", "hide": false, "flex": 0.6},
            {"colId": "sale_data_sent.0.entity", "hide": false, "flex": 0.6},
            {"colId": "sale_data_sent.0.status", "hide": false, "flex": 0.6},
            {"colId": "sale_data_sent.0.retry", "hide": false, "flex": 0.6},
            {"colId": "sale_data_sent.0.reason_failed", "hide": false, "flex": 2},
            {"colId": "params", "minWidth":62, "width": 62, "hide": false, "pinned": "right"}
        ],
        mobile_columns: [
            {"colId": "0", "minWidth": 50, "width": 50, "hide": false, "pinned": "left"},
            {"colId": "closed_at", "hide": false, "flex": 0.8},
            {"colId": "final_amount", "hide": false, "flex": 0.8},
            {"colId": "sale_data_sent.0.status", "hide": false, "flex": 1},
            {"colId": "params", "minWidth":62, "width": 62, "hide": false, "pinned": "right"}
        ]
    }

    static history_e_invoices: BaseModel = {
        tablet_columns: [
            {"colId": "0", "minWidth": 50, "width": 50, "hide": false, "pinned": "left"},
            {"colId": "e_invoice_number", "hide": false, "flex": 0.4},
            {"colId": "customer_name", "hide": false, "flex": 0.8},
            {"colId": "final_amount", "hide": false, "flex": 0.5},
            {"colId": "closed_at", "hide": false, "flex": 0.6},
            {"colId": "status", "hide": false, "flex": 0.5},
            {"colId": "params", "minWidth":62, "width": 62, "hide": false, "pinned": "right"}
        ],
        mobile_columns: [
            {"colId": "0", "minWidth": 50, "width": 50, "hide": false, "pinned": "left"},
            {"colId": "customer_name", "hide": false, "flex": 1},
            {"colId": "final_amount", "hide": false, "flex": 0.5},
            {"colId": "closed_at", "hide": false, "flex": 0.6},
            {"colId": "params", "minWidth":62, "width": 62, "hide": false, "pinned": "right"}
        ]
    }

    static giftcards: BaseModel = {
        tablet_columns: [
            {"colId": "0", "minWidth": 50, "width": 50, "hide": false, "pinned": "left"},
            {"colId": "code", "hide": false, "flex": 1},
            {"colId": "initial_value", "hide": false, "flex": 1},
            {"colId": "last_value", "hide": false, "flex": 1},
            {"colId": "is_divisible", "hide": false, "flex": 1},
            {"colId": "valid_since", "hide": false, "flex": 1},
            {"colId": "valid_until", "hide": false, "flex": 1},
            {"colId": "active", "hide": false, "flex": 1},
            {"colId": "params", "minWidth":62, "width": 62, "hide": false, "pinned": "right"}
        ],
        mobile_columns: [
            {"colId": "0", "minWidth": 50, "width": 50, "hide": false, "pinned": "left"},
            {"colId": "code", "hide": false, "flex": 1},
            {"colId": "active", "hide": false, "flex": 1},
            {"colId": "params", "minWidth":62, "width": 62, "hide": false, "pinned": "right"}
        ],
    };
    static settings_um_static_token: BaseModel = {
        tablet_columns: [
            {"colId": "0", "minWidth": 50, "width": 50, "hide": false, "pinned": "left"},
            {"colId": "trunc_token", "hide": false, "flex": 1},
            {"colId": "description", "hide": false, "flex": 1},
            {"colId": "client_id", "hide": false, "flex": 1},
            {"colId": "created_at", "hide": false, "flex": 1},
            {"colId": "username", "hide": false, "flex": 1},
            {"colId": "params", "minWidth":62, "width": 62, "hide": false, "pinned": "right"}
        ],
        mobile_columns: [
            {"colId": "0", "minWidth": 50, "width": 50, "hide": false, "pinned": "left"},
            {"colId": "trunc_token", "hide": false, "flex": 1},
            {"colId": "description", "hide": false, "flex": 1},
            {"colId": "client_id", "hide": false, "flex": 1},
            {"colId": "created_at", "hide": false, "flex": 1},
            {"colId": "username", "hide": false, "flex": 1},
            {"colId": "params", "minWidth":62, "width": 62, "hide": false, "pinned": "right"}
        ]
    };
    static history_cash_movements: BaseModel = {
        tablet_columns: [
            {"colId": "0", "minWidth": 50, "width": 50, "hide": false, "pinned": "left"},
            {"colId": "movement_type", "hide": false, "flex": 1},
            {"colId": "date", "hide": false, "flex": 1},
            {"colId": "description", "hide": false, "flex": 1},
            {"colId": "amount", "hide": false, "flex": 1},
            {"colId": "movement_account", "hide": false, "flex": 1},
            {"colId": "payment_method_name", "hide": false, "flex": 1},
            {"colId": "params", "minWidth":62, "width": 62, "hide": false, "pinned": "right"}
        ],
        mobile_columns: [
            {"colId": "0", "minWidth": 50, "width": 50, "hide": false, "pinned": "left"},
            {"colId": "movement_type", "hide": false, "flex": 1},
            {"colId": "date", "hide": false, "flex": 1},
            {"colId": "description", "hide": false, "flex": 1},
            {"colId": "params", "minWidth":62, "width": 62, "hide": false, "pinned": "right"}
        ]
    };
    static file_importer: BaseModel = {
        tablet_columns: [
            {"colId": "0", "minWidth": 50, "width": 50, "hide": false, "pinned": "left"},
            {"colId": "status", "hide": false, "flex": 1},
            {"colId": "name", "hide": false, "flex": 1},
            {"colId": "dateToProcess", "hide": false, "flex": 1},
            {"colId": "typeInsert", "hide": false, "flex": 1},
            {"colId": "totalRows", "hide": false, "flex": 1},
            {"colId": "rowsProcessed", "hide": false, "flex": 1},
            {"colId": "totalErrors", "minWidth":62, "width": 62, "hide": false},
            {"colId": "params", "minWidth":62, "width": 62, "hide": false, "pinned": "right"}
        ],
        mobile_columns: [
            {"colId": "0", "minWidth": 50, "width": 50, "hide": false, "pinned": "left"},
            {"colId": "status", "hide": false, "flex": 1},
            {"colId": "name", "hide": false, "flex": 1},
            {"colId": "dateToProcess", "hide": false, "flex": 1},
            {"colId": "typeInsert", "hide": false, "flex": 1},
            {"colId": "totalRows", "hide": false, "flex": 1},
            {"colId": "rowsProcessed", "hide": false, "flex": 1},
            {"colId": "totalErrors", "minWidth":62, "width": 62, "hide": false},
            {"colId": "params", "minWidth":62, "width": 62, "hide": false, "pinned": "right"}
        ]
    };
    static file_exporter: BaseModel = {
        tablet_columns: [
            {"colId": "0", "minWidth": 20, "width": 20, "hide": false, "pinned": "left"},
            {"colId": "status", "hide": false, "flex": 1},
            {"colId": "created_at", "hide": false, "flex": 1},
            {"colId": "table", "hide": false, "flex": 1},
            {"colId": "completed_at", "hide": true, "flex": 1},
            {"colId": "createdby_id", "hide": true, "flex": 1},
            {"colId": "format", "hide": true, "flex": 1},
            {"colId": "params", "minWidth":62, "width": 62, "hide": false, "pinned": "right"}
        ],
        mobile_columns: [
            {"colId": "0", "hide": false, "pinned": "left"},
            {"colId": "status", "hide": false, "flex": 1},
            {"colId": "created_at", "hide": false, "flex": 1},
            {"colId": "table", "hide": false, "flex": 1},
            {"colId": "completed_at", "hide": true, "flex": 1},
            {"colId": "createdby_id", "hide": true, "flex": 1},
            {"colId": "format", "hide": true, "flex": 1},
            {"colId": "params", "minWidth":62, "width": 62, "hide": false, "pinned": "right"}
        ]
    };
    static promotions: BaseModel = {
        tablet_columns: [
            {"colId": "status", "width": 25, "hide": false, "flex": 1},
            {"colId": "name", "hide": false, "flex": 1},
            {"colId": "items", "hide": false, "flex": 1},
            {"colId": "startData", "hide": false, "flex": 1},
            {"colId": "endData", "hide": false, "flex": 1},
            {"colId": "startTime", "hide": false, "flex": 1},
            {"colId": "endTime", "hide": false, "flex": 1},
            {"colId": "weekDays", "hide": false, "flex": 1},
            {"colId": "fidelity_rule", "hide": false, "flex": 1},
            {"colId": "customer_type", "hide": false, "flex": 1},
            {"colId": "params", "minWidth":62, "width": 62, "hide": false, "pinned": "right"}
        ],
        mobile_columns: [
            {"colId": "name", "hide": false, "flex": 1},
            {"colId": "items", "hide": false, "flex": 1},
            {"colId": "params", "minWidth":62, "width": 62, "hide": false, "pinned": "right"}
        ]
    };
    static history_products_deleted: BaseModel = {
        tablet_columns: [
            {"colId": "checkbox", "minWidth": 50, "width": 50, "hide": false, "pinned": "left"},
            {"colId": "sale_item_deleted_at", "hide": false, "flex": 1},
            {"colId": "lastupdate_at", "hide": true, "flex": 1},
            {"colId": "sale_id", "hide": true, "flex": 1},
            {"colId": "sale_name", "hide": false, "flex": 1},
            {"colId": "item_id", "hide": true, "flex": 1},
            {"colId": "name", "hide": false, "flex": 1},
            {"colId": "sku", "hide": false, "flex": 1},
            {"colId": "category_name", "hide": false, "flex": 1},
            {"colId": "department_name", "hide": false, "flex": 1},
            {"colId": "vat_perc", "hide": false, "flex": 1},
            {"colId": "price", "hide": false, "flex": 1},
            {"colId": "cost", "hide": false, "flex": 1},
            {"colId": "operator_name", "hide": false, "flex": 1},
            {"colId": "quantity_difference", "hide": false, "flex":1},
            {"colId": "revenues", "hide": false, "flex":1},
            {"colId": "room_name", "hide": false, "flex": 1},
            {"colId": "table_name", "hide": false, "flex": 1},
            {"colId": "covers", "hide": false, "flex": 1},
            {"colId": "order_type", "hide": false, "flex": 1},
        ],
        mobile_columns: [
            {"colId": "checkbox", "minWidth": 50, "width": 50, "hide": false, "pinned": "left"},
            {"colId": "sale_item_deleted_at", "hide": false, "flex": 1},
            {"colId": "lastupdate_at", "hide": true, "flex": 1},
            {"colId": "sale_id", "hide": true, "flex": 1},
            {"colId": "sale_name", "hide": false, "flex": 1},
            {"colId": "item_id", "hide": true, "flex": 1},
            {"colId": "name", "hide": false, "flex": 1},
            {"colId": "sku", "hide": false, "flex": 1},
            {"colId": "category_name", "hide": false, "flex": 1},
            {"colId": "department_name", "hide": false, "flex": 1},
            {"colId": "vat_perc", "hide": false, "flex": 1},
            {"colId": "price", "hide": false, "flex": 1},
            {"colId": "cost", "hide": false, "flex": 1},
            {"colId": "operator_name", "hide": false, "flex": 1},
            {"colId": "quantity_difference", "hide": false, "flex":1},
            {"colId": "revenues", "hide": false, "flex":1},
            {"colId": "room_name", "hide": false, "flex": 1},
            {"colId": "table_name", "hide": false, "flex": 1},
            {"colId": "covers", "hide": false, "flex": 1},
            {"colId": "order_type", "hide": false, "flex": 1},
        ]
    };

    static items: BaseModel = {
        tablet_columns: [
            {"colId": "checkbox", "minWidth": 50, "width": 50, "hide": false, "pinned": "left"},
            {"colId": "name", "minWidth": 350, "hide": false, "flex": 2},
            {"colId": "sku", "hide": false, "flex": 0.85},
            {"colId": "item_barcodes", "hide": false, "flex": 0.85},
            {"colId": "code", "hide": false, "flex": 1},
            {"colId": "price1", "hide": false, "flex": 0.6},
            {"colId": "cost", "hide": false, "flex": 0.6},
            {"colId": "category_name", "hide": false, "flex": 1},
            {"colId": "department_name", "hide": false, "flex": 1},
            {"colId": "favorite", "hide": false, "flex": 0.6},
            {"colId": "params", "minWidth":62, "width": 62, "hide": false, "pinned": "right"}
        ],
        mobile_columns: [
            {"colId": "checkbox", "minWidth": 50, "width": 50, "hide": false, "pinned": "left"},
            {"colId": "name", "minWidth": 230, "hide": false, "flex": 1.5},
            {"colId": "price1", "hide": false, "flex": 0.6},
            {"colId": "department_name", "hide": false, "flex": 1},
            {"colId": "favorite", "hide": false, "flex": 0.55},
            {"colId": "params", "minWidth":62, "width": 62, "hide": false, "pinned": "right"}
        ],
    };

    static categories: BaseModel = {
        tablet_columns: [
            {"colId": "0", "minWidth": 50, "width": 50, "hide": false, "pinned": "left"},
            {"colId": "name", "hide": false, "flex": 1.5},
            {"colId": "printer_name", "hide": false, "flex": 1},
            {"colId": "department_name", "hide": false, "flex": 1},
            {"colId": "display", "hide": false, "flex": 0.7},
            {"colId": "display_kiosk", "hide": false, "flex": 0.7},
            {"colId": "display_slave_device", "hide": false, "flex": 0.7},
            {"colId": "params", "minWidth":62, "width": 62, "hide": false, "pinned": "right"}
        ],
        mobile_columns: [
            {"colId": "0", "minWidth": 50, "width": 50, "hide": false, "pinned": "left"},
            {"colId": "name", "hide": false, "flex": 1},
            {"colId": "printer_name", "hide": false, "flex": 1},
            {"colId": "department_name", "hide": false, "flex": 1},
            {"colId": "display", "hide": false, "flex": 0.7},
            {"colId": "params", "minWidth":62, "width": 62, "hide": false, "pinned": "right"}
        ],
    };

    static components: BaseModel = {
        tablet_columns: [
            {"colId": "0", "minWidth": 50, "width": 50, "hide": false, "pinned": "left"},
            {"colId": "name", "hide": false, "flex": 1},
            {"colId": "price_difference", "hide": false, "flex": 1},
            {"colId": "params", "minWidth":62, "width": 62, "hide": false, "pinned": "right"}
        ],
        mobile_columns: [
            {"colId": "0", "minWidth": 50, "width": 50, "hide": false, "pinned": "left"},
            {"colId": "name", "hide": false, "flex": 1},
            {"colId": "price_difference", "hide": false, "flex": 1},
            {"colId": "params", "minWidth":62, "width": 62, "hide": false, "pinned": "right"}
        ],
    }

    static raw_materials: BaseModel = {
        tablet_columns: [
            {"colId": "0", "minWidth": 50, "width": 50, "hide": false, "pinned": "left"},
            {"colId": "name", "hide": false, "flex": 1},
            {"colId": "cost", "hide": false, "flex": 1},
            {"colId": "stock_type", "hide": false, "flex": 1},
            {"colId": "auto_unload", "hide": false, "flex": 1},
            {"colId": "params", "minWidth":62, "width": 62, "hide": false, "pinned": "right"}
        ],
        mobile_columns: [
            {"colId": "0", "minWidth": 50, "width": 50, "hide": false, "pinned": "left"},
            {"colId": "name", "hide": false, "flex": 1},
            {"colId": "cost", "hide": false, "flex": 1},
            {"colId": "params", "minWidth":62, "width": 62, "hide": false, "pinned": "right"}
        ],
    }

    static departments: BaseModel = {
        tablet_columns: [
            {"colId": "0", "minWidth": 50, "width": 50, "hide": false, "pinned": "left"},
            {"colId": "name", "hide": false, "flex": 1},
            {"colId": "display", "hide": false, "flex": 1},
            {"colId": "sales_type", "hide": false, "flex": 1},
            {"colId": "not_discountable", "hide": false, "flex": 1},
            {"colId": "params", "minWidth":62, "width": 62, "hide": false, "pinned": "right"}
        ],
        mobile_columns: [
            {"colId": "0", "minWidth": 50, "width": 50, "hide": false, "pinned": "left"},
            {"colId": "name", "hide": false, "flex": 1},
            {"colId": "sales_type", "hide": false, "flex": 1},
            {"colId": "params", "minWidth":62, "width": 62, "hide": false, "pinned": "right"}
        ],
    }


    static vat_rates: BaseModel = {
        tablet_columns: [
            {"colId": "0", "minWidth": 50, "width": 50, "hide": false, "pinned": "left"},
            {"colId": "id", "hide": false, "flex": 1},
            {"colId": "value", "hide": false, "flex": 1},
            {"colId": "code", "hide": false, "flex": 1},
            {"colId": "params", "minWidth":62, "width": 62, "hide": false, "pinned": "right"}
        ],
        mobile_columns: [
            {"colId": "0", "minWidth": 50, "width": 50, "hide": false, "pinned": "left"},
            {"colId": "id", "hide": false, "flex": 1},
            {"colId": "value", "hide": false, "flex": 1},
            {"colId": "code", "hide": false, "flex": 1},
            {"colId": "params", "minWidth":62, "width": 62, "hide": false, "pinned": "right"}
        ],
    }

    static stock: BaseModel = {
        tablet_columns: [   
            {"colId": "0", "minWidth": 50, "width": 50, "hide": false, "pinned": "left"},
            {"colId": "name", "hide": false, "flex": 1},
            {"colId": "details", "hide": false, "flex": 1},
            {"colId": "stock_quantity", "hide": false, "flex": 1},
            {"colId": "available", "hide": false, "flex": 1},
            {"colId": "value", "hide": false, "sortable": false, "filter": false, "flex": 1},
            {"colId": "lastupdate_at", "hide": false, "flex": 1},
            {"colId": "id", "hide": true, "flex": 1},
            {"colId": "stock_location_id", "hide": true, "flex": 1},
            {"colId": "item_id", "hide": true, "flex": 1},
            {"colId": "combination_id", "hide": true, "flex": 1},
            {"colId": "raw_material_id", "hide": true, "flex": 1},
            {"colId": "item_on_sale", "hide": true, "flex": 1},
            {"colId": "barcode", "hide": true, "flex": 1},
            {"colId": "code", "hide": true, "flex": 1},
            {"colId": "options_values", "hide": true, "flex": 1},
            {"colId": "combination", "hide": true, "flex": 1},
            {"colId": "params", "minWidth":62, "width": 62, "hide": false, "pinned": "right"}
        ],
        mobile_columns: [
            {"colId": "0", "minWidth": 50, "width": 50, "hide": false, "pinned": "left"},
            {"colId": "name", "hide": false, "flex": 1},
            {"colId": "stock_quantity", "hide": false, "flex": 1},
            {"colId": "available", "hide": false, "flex": 1},
            {"colId": "params", "minWidth":62, "width": 62, "hide": false, "pinned": "right"}
        ]
    }

    static stock_movements: BaseModel = {
        tablet_columns: [
            {"colId": "date", "hide": false, "flex": 1},
            {"colId": "supplier_order", "hide": false, "flex": 1},
            {"colId": "operator_fullname", "hide": false, "flex": 1},
            {"colId": "supplier_name", "hide": false, "flex": 1},
            {"colId": "movement_type", "hide": false, "flex": 1},
            {"colId": "params", "minWidth":62, "width": 62, "hide": false, "pinned": "right"}
        ],
        mobile_columns: [
            {"colId": "date", "hide": false, "flex": 1},
            {"colId": "supplier_order", "hide": true, "flex": 1},
            {"colId": "operator_fullname", "hide": false, "flex": 1},
            {"colId": "supplier_name", "hide": true, "flex": 1},
            {"colId": "movement_type", "hide": false, "flex": 1},
            {"colId": "params", "minWidth":62, "width": 62, "hide": false, "pinned": "right"}
        ],
    };

    static stock_movements_search: BaseModel = {
        tablet_columns: [
            {"colId": "name", "hide": false, "flex": 1},
            {"colId": "quantity", "hide": false, "flex": 0.5},
            {"colId": "price", "hide": false, "flex": 0.9},
            {"colId": "perc_discount", "hide": false, "flex": 0.5},
            {"colId": "row_amount", "hide": false, "flex": 0.5},
            {"colId": "movement_type", "hide": false, "flex": 1},
            {"colId": "date", "hide": false, "flex": 0.7},
            {"colId": "supplier_name", "hide": false, "flex": 0.9},
            {"colId": "supplier_order", "hide": false, "flex": 0.5},
            {"colId": "params", "minWidth":62, "width": 62, "hide": false, "pinned": "right"}
        ],
        mobile_columns: [
            {"colId": "name", "hide": false, "flex": 1},
            {"colId": "quantity", "hide": false, "flex": 0.5},
            {"colId": "price", "hide": true, "flex": 0.9},
            {"colId": "perc_discount", "hide": true, "flex": 0.5},
            {"colId": "row_amount", "hide": true, "flex": 0.5},
            {"colId": "movement_type", "hide": false, "flex": 1},
            {"colId": "date", "hide": false, "flex": 0.7},
            {"colId": "supplier_name", "hide": true, "flex": 0.9},
            {"colId": "supplier_order", "hide": true, "flex": 0.5},
            {"colId": "params", "minWidth":62, "width": 62, "hide": false, "pinned": "right"}
        ],
    };
}

